const PlayerStatItem: React.FC<{ label: string, value: string | number | undefined }> = ({ label, value }) => {
    return (
        <div className="flex items-center gap-2">
            <p className="text-zinc-700 text-sm uppercase">{label}</p>
            <div className="border-b flex-auto"></div>
            <p className="text-zinc-700 text-sm uppercase font-bold">{value}</p>
        </div>
    )
}

export default PlayerStatItem